import { DateTime } from "luxon";
import { Control, Controller, FieldValues, Path } from "react-hook-form";
import { DatePickerInput } from "../inputs/DatePickerInput";

export type FormDatePickerProps<
	TFieldValues extends FieldValues,
	TTransformedValues = TFieldValues,
> = {
	defaultMonth?: DateTime;
	className?: string;
	fromDate?: DateTime;
	toDate?: DateTime;
	disableBefore?: string | null;
	disableAfter?: string | null;
	disableDays?: string[];
	control: Control<TFieldValues, any, TTransformedValues>;
	name: Path<TFieldValues>;
	errorMessage?: string;
	readonly?: boolean;
	compact?: boolean;
};

export const FormDatePicker = <
	TFieldValues extends FieldValues,
	TTransformedValues = TFieldValues,
>({
	control,
	name,
	...props
}: FormDatePickerProps<TFieldValues, TTransformedValues>) => (
	<Controller
		name={name}
		control={control}
		render={({ field: { ref, ...field }, fieldState }) => (
			<DatePickerInput
				{...field}
				{...props}
				error={fieldState.invalid ? fieldState.error : undefined}
			/>
		)}
	/>
);
